import React from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'

import { MapLinkBase } from './styles'
import { buildLocation } from 'lib/utils/page'
import { getSearch } from 'src/effects/Search/selectors'
import { scrollToTop } from 'client/utils'
import { routes } from 'src/constants/routes'
import { useKafkaEvent } from 'src/hooks/useKafkaEvent'
import { usePage } from 'src/hooks/usePage'
import { SECTIONS } from 'src/hooks/useKafkaEvent/constants'

interface MapLinkProps {
  children: React.ReactNode
  propertyId?: number
}

const MapLink = ({ children, propertyId }: MapLinkProps) => {
  const router = useRouter()
  const { pageId } = usePage()
  const searchParams = useSelector(getSearch)
  const { sendEvent } = useKafkaEvent({ page: pageId, eventName: 'show_on_map' })

  function getDestinationUrl(query: Record<string, string | string[]>) {
    if (propertyId) {
      return buildLocation({
        page: routes.map.page,
        path: { country: searchParams.country, type: searchParams.type, slug: searchParams.slug },
        query: { ...query, highlightedProperty: `${propertyId}` },
      })
    }

    return buildLocation({
      page: routes.map.page,
      path: searchParams,
      query,
    })
  }

  function goToMap(query = {}) {
    const destinationUrl = getDestinationUrl({ ...query, internal_navigation: 'true' })

    scrollToTop()

    router.push(destinationUrl.href, destinationUrl.as)
  }

  const { query } = useRouter()

  const handleClick = () => {
    sendEvent({ section: SECTIONS.HEADER })
    goToMap(query)
  }

  return <MapLinkBase onClick={handleClick}>{children}</MapLinkBase>
}

export default MapLink
